import appLogger from "@next-platform/client-common-core/logger/appLogger";

const checkoutTokenHandoffLogger = appLogger.withTag("CheckoutTokenHandoff");

export default checkoutTokenHandoffLogger;
